import { ServerApi } from 'modules/api/server-api';

import { decodeSpecialization } from '@/models/Specialization';

export const fetchSpecializations = (api: ServerApi) => async () => {
  const response = await api.get('/dictionary/specializations');
  return response.data.specializations.map((item: any) => decodeSpecialization(item));
};
